import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import * as DateTime from 'react-datetime';
import { Prompt, withRouter } from 'react-router';
import { Button, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import DataTable from 'src/Components/DataTable';
import EInput, { EButton, EInputMask } from 'src/Components/EInput';
import OpenArrow from 'src/Components/OpenArrow/OpenArrow';
import { IDispatchItem, IDispatchTruck, IDispatchUpdate } from 'src/Interfaces/DispatchInterface';
import { IEBPExpenseType, IProduct } from 'src/Interfaces/TestInterface';
import { IWell } from 'src/Interfaces/WellInterface';
import { DispatchStore } from 'src/Stores/Dispatch/DispatchStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';

const boldStyle = {
    fontWeight: 700
};

const fontSizeStyle = {
    fontSize: '1.3rem'
};

const leftColumnWidth = 6;
const rightColumnWidth = 6;

const mask = new EInputMask();

interface IReallocation {
    sourceOrdinal: number | string;
    destOrdinal: number | string;
    quantity: number;
}

@inject('stores')
@observer
export class DispatchDetails extends React.Component {

    public DispatchStore: DispatchStore;
    public UserStore: UserStore;
    private MessageStore: MessageStore;
    private TestsStore: TestsStore;
    private WellsStore: WellsStore;
    public props: any;

    private dispatchDisposer: any;

    public state = {
        comment: '',
        dataTableItems: [] as any[],
        destinationWellId: '',
        disableEditing: true,
        dispatchItem: undefined as unknown as IDispatchItem,
        dispatchTruckOpen: [true] as boolean[],
        dispatchTrucks: [] as IDispatchTruck[],
        dispatchTrucksHaveEta: [] as boolean[],
        dropdownOpen: false,
        expenseList: [] as IEBPExpenseType[],
        isDirty: false,
        newExpenseList: [] as IEBPExpenseType[],
        newInventoryList: [] as IProduct[],
        productList: [] as IProduct[],
        reallocateModal: false,
        reallocations: [] as IReallocation[],
        showProductModal: false,
        statusIndex: 0,
        tab: 'product',
        wellList: [] as IWell[],
    };
    

    
    constructor(props: any) {
        super(props);
        this.DispatchStore = props.stores.DispatchStore;
        this.UserStore = props.stores.UserStore;
        this.MessageStore = props.stores.MessageStore;
        this.TestsStore = props.stores.TestsStore;
        this.WellsStore = props.stores.WellsStore;
    }

    public componentDidMount() {
        this.createDisposers();
        this.DispatchStore.getDispatch(this.props.match.params.dispatchId);
        this.WellsStore.getWellsNoFilter()
            .then(wellList => {
                this.setState({wellList});
        });
        this.props.stores.WellsStore.clearWell();
    }

    public toggleDropdown = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    public createDisposers = () => {
        this.dispatchDisposer = observe(this.DispatchStore, 'dispatch', change => {
            if (change.newValue) {
                const truckLength = change.newValue.dispatchHistory[this.state.statusIndex].trucks.length;
                const dispatchTrucksHaveEta = change.newValue.dispatchHistory[0].trucks.map(dt => Boolean(dt.estimatedArrival));
                this.setState({
                    dispatchTruckOpen: new Array(truckLength).fill(true),
                    dispatchTrucks: change.newValue.dispatchHistory[this.state.statusIndex].trucks,
                    dispatchTrucksHaveEta,
                });

            }
        });
    }

    public componentWillUnmount() {
        this.dispatchDisposer();
    }
    public changeDisplayStatus = (statusIndex: number) => (event: any) => {
        
        this.setState({
            disableEditing: true,
            dispatchTrucks: this.DispatchStore.dispatch.dispatchHistory[statusIndex].trucks,
            statusIndex
        });
    }

    private getProductsForModal = (wellId: string) => {
        this.TestsStore.getProductList(wellId)
            .then(productList => {
                if (productList) {
                    this.setState({
                        productList
                    });
                }
            });
        this.TestsStore.getExpenseTypes(wellId)
            .then(expenseList => {
                if (expenseList) {
                    this.setState({
                        expenseList
                    });
                }
            });
    }

    private toggleModal = (type: string) => () => {
        const { productList, expenseList, showProductModal } = this.state;
        if (!showProductModal && (productList.length === 0 || expenseList.length === 0)) {
            this.getProductsForModal(this.DispatchStore.dispatch.dispatchHistory[0].dispatchHeader.destinationWellId);
        } 
        
        if (showProductModal) {
            this.setState({
                newExpenseList: [],
                newInventoryList: [],
                showProductModal: !showProductModal,
            });
        } else {
            this.setState({
                showProductModal: !showProductModal,
                tab: type,
            });
        }
    }

    private handleMultiSelect = (listType:string) => (index: number) => {
        if (listType === 'product') {
            const filteredProductList = this.state.productList.filter(this.filterAddProduct);
            const filteredIndex = this.state.newInventoryList.indexOf(filteredProductList[index]);
            if ( filteredIndex !== -1 ) {
                this.state.newInventoryList.splice(filteredIndex, 1);
            } else {
                this.state.newInventoryList.push(filteredProductList[index]);
            }
        } else {
            const filteredExpenseList = this.state.expenseList.filter(this.filterAddExpense);
            const filteredIndex = this.state.newExpenseList.indexOf(filteredExpenseList[index]);
            if ( filteredIndex !== -1) {
                this.state.newExpenseList.splice(filteredIndex, 1);
            } else {
                this.state.newExpenseList.push(filteredExpenseList[index]);
            }
        }
    }

    private filterAddProduct = (product: IProduct) => {
        return this.state.dispatchTrucks.every(dt => dt.items.every(p => p.productId !== product.id));
    }

    private filterAddExpense = (expense: IEBPExpenseType) => {
        return expense.dispatchable && this.state.dispatchTrucks.every(dt => dt.items.every(p => p.expenseId !== expense.id));
    }

    private formatAddProductDataTable = () => {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Product',
            'Category',
            'Unit',
            'Size',
            'Weight',
            'Price'
        ];
        if ( this.state.productList ) {
            this.state.productList.filter(this.filterAddProduct).map((product: IProduct, index: number) => {
                const newObject = [
                    {
                        content: product.name
                    },
                    {
                        content: product.categorys[0].name
                    },
                    {
                        content: product.unit
                    },
                    {
                        content: product.size
                    },
                    {
                        content: product.weight
                    },
                    {
                        content: product.retailPrice
                    }
                ];
                newDataList.push(newObject);
            });
        }
        return {
            headers: tableHeaders,
            rows: newDataList
        };
    }

    private formatAddExpenseDataTable = () => {
        const headers = [
            'EBP',
            'Type',
        ];
        let rows = [] as any[];
        if (this.state.expenseList) {
            rows = this.state.expenseList.filter(this.filterAddExpense).map(expense => [
                {
                    content: expense.name,
                },
                {
                    content: expense.isRental ? 'Rental' : 'Service',
                },
            ]);
        }

        return {headers, rows};
    }

    private handleStatusChange = (status: string) => () => {
        let areYouSure = true;
        if (status === 'Cancelled') {
            areYouSure = confirm("Are you sure you would like to cancel this dispatch?");
        }
        if (areYouSure) {
            const currDispatch = this.DispatchStore.dispatch.dispatchHistory[0];
            this.DispatchStore.updateDispatchStatus(this.DispatchStore.dispatch.id, {
                comment: '',
                destinationWellId: status === 'Approved' && this.state.destinationWellId !== '' ? this.state.destinationWellId : null,
                estimatedArrival: currDispatch.estimatedArrival,
                id: '',
                requestedArrival: currDispatch.requestedArrival,
                status,
            })
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage(`Dispatch ${status}.`, 'success');
                    this.DispatchStore.getDispatch(this.props.match.params.dispatchId);
                }
            });
        }
    }
    // private handleApprove = () => {
    //     const currDispatch = this.DispatchStore.dispatch.dispatchHistory[0];
    //     this.DispatchStore.updateDispatchStatus(this.DispatchStore.dispatch.id, {
    //         comment: '',
    //         destinationWellId: this.state.destinationWellId === '' ? null : this.state.destinationWellId,
    //         estimatedArrival: currDispatch.estimatedArrival,
    //         id: '',
    //         requestedArrival: currDispatch.requestedArrival,
    //         status: 'Approved',
    //     })
    //     .then(data => {
    //         if (data) {
    //             this.MessageStore.addMessage('Dispatch Approved.', 'success');
    //             this.DispatchStore.getDispatch(this.props.match.params.dispatchId);
    //         }
    //     });
    // }

    // private handleReject = () => {
    //     const currDispatch = this.DispatchStore.dispatch.dispatchHistory[0];
    //     this.DispatchStore.updateDispatchStatus(this.DispatchStore.dispatch.id, {
    //         comment: '',
    //         estimatedArrival: currDispatch.estimatedArrival,
    //         id: '',
    //         requestedArrival: currDispatch.requestedArrival,
    //         status: 'Rejected',
    //     })
    //     .then(data => {
    //         if (data) {
    //             this.MessageStore.addMessage('Dispatch Rejected.', 'success');
    //             this.DispatchStore.getDispatch(this.props.match.params.dispatchId);
    //         }
    //     });
    // }

    // private handleConfirm = () => {
    //     const currDispatch = this.DispatchStore.dispatch.dispatchHistory[0];
    //     this.DispatchStore.updateDispatchStatus(this.DispatchStore.dispatch.id, {
    //         comment: '',
    //         estimatedArrival: currDispatch.estimatedArrival,
    //         id: '',
    //         requestedArrival: currDispatch.requestedArrival,
    //         status: 'Confirmed',
    //     })
    //     .then(data => {
    //         if (data) {
    //             this.MessageStore.addMessage('Dispatch Confirmed.', 'success');
    //             this.DispatchStore.getDispatch(this.props.match.params.dispatchId);
    //         }
    //     });
    // }

    // private handleDeny = () => {
    //     const currDispatch = this.DispatchStore.dispatch.dispatchHistory[0];
    //     this.DispatchStore.updateDispatchStatus(this.DispatchStore.dispatch.id, {
    //         comment: '',
    //         estimatedArrival: currDispatch.estimatedArrival,
    //         id: '',
    //         requestedArrival: currDispatch.requestedArrival,
    //         status: 'Denied',
    //     })
    //     .then(data => {
    //         if (data) {
    //             this.MessageStore.addMessage('Dispatch Denied.', 'success');
    //             this.DispatchStore.getDispatch(this.props.match.params.dispatchId);
    //         }
    //     });
    // }

    private handleTruckDelivery = (dispatchTruck: IDispatchTruck) => () => {
        this.DispatchStore.setTruckDelivered(dispatchTruck.id)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('Dispatch Truck Delivered.', 'success');
                    this.DispatchStore.getDispatch(this.props.match.params.dispatchId);
                }
            });
    }

    private handleTruckCompleted = (dispatchTruck: IDispatchTruck) => () => {
        this.DispatchStore.setTruckCompleted(dispatchTruck.id)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('Dispatch Truck Completed.', 'success');
                    this.DispatchStore.getDispatch(this.props.match.params.dispatchId);
                }
            });
    } 

    private handleQuantityInput = (type:string, truckNumber: number, index: number) => (event: any) => {
        const list = this.state.dispatchTrucks;
        const row = list[truckNumber - 1].items[index] as IDispatchItem;
        if (Number.isInteger(Number(event.target.value))) {
            row.quantity = Number(event.target.value);
        }
        this.setState({
            dispatchTrucks: list,
        });
    }

    private handlePriceInput = (type: string, truckNumber: number, index: number) => (event: any) => {
        const list = this.state.dispatchTrucks;
        const row = list[truckNumber - 1].items[index] as IDispatchItem;
        if (Number.isFinite(Number(event.target.value))) {
            row.price = event.target.value;
        }
        this.setState({
            dispatchTrucks: list,
        });
    }
    // private handleCheck = (type:string, truckNumber:number, index: number) => (event: any) => {
    //     const list = this.state.dispatchTrucks;
    //     const row = list[truckNumber].items[index] as IDispatchItem;
    //     if (row.quantity > 0) {
    //         row.quantity = '';
    //     } else {
    //         row.quantity = 1;
    //     }
    //     this.setState({
    //         dispatchTrucks: list,
    //     });
    // }
    private handleEstimatedArrivalChange = (index: number) => (newDate: any) => {
        const dispatchTrucks = this.state.dispatchTrucks;
        const truck = dispatchTrucks[index];
        const newDateValue = moment(newDate).unix();
        if (isFinite(newDateValue)) {
            truck.estimatedArrival = newDateValue.toString();
        } else {
            truck.estimatedArrival = undefined as unknown as string;
        }
        this.setState({
            dispatchTrucks,
        });
    }
    private handleTruckOpen = (index: number) => () => {
        const dispatchTruckOpen = this.state.dispatchTruckOpen;
        dispatchTruckOpen[index] = !dispatchTruckOpen[index];
        this.setState({dispatchTruckOpen});
    }

    // private createCheckBox = (type:string, truckNumber:number, index: number, row: IDispatchItem) => () => {
    //     return <FormGroup style={{textAlign: 'center'}} >
    //                 <Label check={true}>
    //                     <Input
    //                         key={index}
    //                         type="checkbox"
    //                         name={`${type}[${index}].check`}
    //                         checked={row.quantity > 0}
    //                         onChange={this.handleCheck(type, truckNumber, index)}
    //                         disabled={this.state.disableEditing}
    //                         />
    //                 </Label>
    //             </FormGroup>;
    // }

    private handleAddComment = () => {
        const comment = this.state.comment.trim();
        if (comment) {
            this.DispatchStore.addComment(comment)
                .then(data => {
                    if (data) {
                        this.MessageStore.addMessage('Comment Added', 'success');
                        this.setState({
                            comment: '',
                        });
                    }
                });
        }
    }

    private clearComment = () => {
        this.setState({
            comment: '',
        });
    }

    private handleChangeComment = (event: any) => {
        const comment = event.target.value;
        this.setState({
            comment
        });
    }
    private createQuantityInput = (type: string, truckNumber:number, index: number, row: IDispatchItem) => () => {
        return <Input
                    key={'quantity' + index + truckNumber}
                    type="text"
                    name={`${type}[${index}][${truckNumber}].quantity`}
                    value={row.quantity}
                    data-validation={row.product && row.product.isBulk ? "decimal" : "integer"}
                    decimal-places="2"
                    onChange={this.handleQuantityInput(type, truckNumber, index)}
                    disabled={this.state.disableEditing}
                />;
    }

    private createPriceInput = (type: string, truckNumber: number, index: number, row: IDispatchItem) => () => {
        return <EInput
                    key={'price' + index + truckNumber}
                    type="text"
                    name={`${type}[${index}][${truckNumber}].quantity`}
                    data-mask="currency"
                    value={row.price}
                    onChange={this.handlePriceInput(type, truckNumber, index)}
                    disabled={this.state.disableEditing}
                />;
    }

    private canEditDispatch = () => {
        const { statusIndex } = this.state;
        if (statusIndex !== 0) {
            return false;
        }
        const currDispatch = this.DispatchStore.dispatch.dispatchHistory[0];
        const { status, dispatchHeader } = currDispatch;

        const isAssigned = this.UserStore.user !== undefined && ((dispatchHeader.sourceWell && dispatchHeader.sourceWell.engineerIds && dispatchHeader.sourceWell.engineerIds.some(id => id === this.UserStore.user.id))
            || (dispatchHeader.destinationWell && dispatchHeader.destinationWell.engineerIds && dispatchHeader.destinationWell.engineerIds.some(id => id === this.UserStore.user.id)));
        
        switch (status) {
            case 'Confirmed':
                if (this.UserStore.hasPermission('Permissions.Dispatch.UpdateConfirmed')) {
                    return true;
                }
                break;
            case 'Approved':
            case 'Denied':
                if (this.UserStore.hasPermission('Permissions.Dispatch.UpdateApproved.All')) {
                    return true;
                } else if (this.UserStore.hasPermission('Permissions.Dispatch.UpdateApproved.Assigned')) {
                    return isAssigned;
                }
                break;
            case 'Submitted':
            case 'Rejected':
                if (this.UserStore.hasPermission('Permissions.Dispatch.UpdateSubmitted.All')) {
                    return true;
                } else if (this.UserStore.hasPermission('Permissions.Dispatch.UpdateSubmitted.Assigned')) {
                    return isAssigned;
                } else if (this.UserStore.hasPermission('Permissions.Dispatch.UpdateRejected.All')) {
                    return true;
                } else if (this.UserStore.hasPermission('Permissions.Dispatch.UpdateRejected.Assigned')) {
                    return isAssigned;
                }
                break;
            default:
                return false;
        }
        return false;
    }

    private canReallocate = () => {
        return this.state.statusIndex === 0
            && this.DispatchStore.dispatch.dispatchHistory[0].status === 'Approved'
            && this.UserStore.hasPermission('Permissions.Dispatch.Allocate');
    }

    private canAddProducts = () => {
        return this.DispatchStore.dispatch.dispatchHistory[0].status !== 'Confirmed'
            && this.DispatchStore.dispatch.dispatchHistory[0].dispatchHeader.destinationWellId !== null
            && this.canEditDispatch();
    }

    private canSetDispatchEstimatedArrival = () => {
        return this.DispatchStore.dispatch.dispatchHistory[0].status === 'Approved'
            && !this.state.disableEditing
            && this.UserStore.hasGenericPermission('Permissions.Dispatch.UpdateApproved');
    }

    private saveDispatch = () => {
        const currDispatch = this.DispatchStore.dispatch;
        const dispatchTrucks = this.state.dispatchTrucks;
        const updatedDispatch = new IDispatchUpdate();
        updatedDispatch.id = currDispatch.id;
        updatedDispatch.trucks = dispatchTrucks;
        this.DispatchStore.putDispatch(updatedDispatch)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('Dispatch Updated', 'success');
                    this.DispatchStore.getDispatch(currDispatch.id);
                    this.setState({isDirty: false});
                }
            });

    }
    private renderDispatchItem = (dispatchItem: IDispatchItem) => {
        if (dispatchItem === undefined) {
            return { headers: [], rows: []};
        }
        if (dispatchItem.productId !== null && dispatchItem.productId !== undefined) {
            const headers = [
                'Product Name',
                'Size',
                'Unit',
                'Price',
                'Quantity',
            ];

            const rows = [
                [
                    dispatchItem.product.name,
                    dispatchItem.product.size,
                    dispatchItem.product.unit,
                    mask.currency(dispatchItem.price),
                    dispatchItem.quantity
                ]
            ];
            return { headers, rows };
        } else {
            const headers = [
                'EBP Item',
                'Type',
                'Total Units',
            ];

            const rows = [
                [
                    dispatchItem.expense.name,
                    dispatchItem.expense.isRental ? 'Rental' : 'Service',
                    dispatchItem.quantity,
                ]
            ];

            return { headers, rows };

        }
    }

    private getCurrentAllocations = () => {
        const { dispatchItem, reallocations } = this.state;
        if (dispatchItem === undefined) {
            return [];
        }
        const trucks = this.state.dispatchTrucks;
        const costAllocations = trucks.map((value, index) => {
            if (dispatchItem.product !== null && dispatchItem.product !== undefined) {
                const dispatchProduct = value.items.find(p => p.productId === dispatchItem.productId);
                if (dispatchProduct) {
                    return {
                        ordinal: value.ordinal,
                        quantity: dispatchProduct.quantity,
                    };
                }
            } else {
                const dispatchExpense = value.items.find(e => e.expenseId === dispatchItem.expenseId);
                if (dispatchExpense) {
                    return {
                        ordinal: value.ordinal,
                        quantity: dispatchExpense.quantity,
                    };
                }
            }
            return undefined;
        }).filter(val => val !== undefined) as any[];
        reallocations.forEach(value => {
            const sourceDispatchItem = costAllocations.find(ic => ic.ordinal === value.sourceOrdinal);
            const destDispatchItem = costAllocations.find(ic => ic.ordinal === value.destOrdinal);
            if (sourceDispatchItem) {
                sourceDispatchItem.quantity -= Number(value.quantity);
            } 
            if (destDispatchItem) {
                destDispatchItem.quantity += Number(value.quantity);
            }
        });
        return costAllocations;
    }

    private addNewReallocation = () => {
        const reallocations = this.state.reallocations;
        reallocations.push({quantity: 0, sourceOrdinal: '', destOrdinal: ''});
        this.setState({
            reallocations,
        });
    }

    private handleSourceDestUpdate = (index: number) => (event: any) => {
        const reallocations = this.state.reallocations;
        const currCR = reallocations[index];
        currCR[event.target.name] = Number(event.target.value);
        this.setState({
            reallocations,
        });
    }

    private handleAmountUpdate = (index: number) => (event: any) => {
        const reallocations = this.state.reallocations;
        const currCR = reallocations[index];
        currCR.quantity = event.target.value;
        this.setState({
            reallocations,
        });

    }

    private handleReallocationDelete = (index: number) => () => {
        const reallocations = this.state.reallocations;
        reallocations.splice(index, 1);
        this.setState({
            reallocations,
        });
    }

    private filterDispatchTrucks = (dispatchTruck: IDispatchTruck) => {
        const { dispatchItem } = this.state;
        if (dispatchItem.product !== null) {
            const dispatchProduct = dispatchTruck.items.find(p => p.productId === dispatchItem.productId);
            return dispatchProduct !== undefined;
        } else {
            const dispatchExpense = dispatchTruck.items.find(e => e.expenseId === dispatchItem.expenseId);
            return dispatchExpense !== undefined;
        }
    }

    private addTruck = () => {
        const { dispatchTrucks, dispatchTruckOpen } = this.state;

        dispatchTrucks.push({
            estimatedArrival: '',
            id: '',
            items: [],
            ordinal: dispatchTrucks.length + 1,
            returnedWellCloseReviewId: '',
            returnedWellTestId: '',
            status: '',
        });
        dispatchTruckOpen.push(true);
        this.setState({
            dispatchTruckOpen,
            dispatchTrucks,
        });
    }

    private removeTruck = (truckIndex: number) => () => {
        const areYouSure = confirm('Are you sure you want to delete this truck?');
        if (areYouSure) {
            const { dispatchTrucks, dispatchTruckOpen } = this.state;
            dispatchTruckOpen.splice(truckIndex, 1);
            dispatchTrucks.splice(truckIndex, 1);
            this.setState({
                dispatchTruckOpen,
                dispatchTrucks,
            });
        }
    }

    private saveReallocation = () => {
        const { reallocations, dispatchItem, dispatchTrucks } = this.state;
        if (dispatchItem.product !== null) {
            reallocations.forEach(value => {
                const sourceTruck = dispatchTrucks.find(ic => ic.ordinal === value.sourceOrdinal);
                const destTruck = dispatchTrucks.find(ic => ic.ordinal === value.destOrdinal);
                if (sourceTruck && destTruck) {
                    const sourceProduct = sourceTruck.items.find(p => p.productId === dispatchItem.productId);
                    const destProduct = destTruck.items.find(p => p.productId === dispatchItem.productId);
                    if (sourceProduct && destProduct) {
                        sourceProduct.quantity -= Number(value.quantity);
                        destProduct.quantity += Number(value.quantity);
                    } else if (sourceProduct) {
                        sourceProduct.quantity -= Number(value.quantity);
                        destTruck.items.push({
                            expense: dispatchItem.expense,
                            expenseId: dispatchItem.expenseId,
                            id: "",
                            price: dispatchItem.price,
                            product: dispatchItem.product,
                            productId: dispatchItem.productId,
                            quantity: Number(value.quantity),
                        });
                    }

                }
            });
        } else {
            reallocations.forEach(value => {
                const sourceTruck = dispatchTrucks.find(ic => ic.ordinal === value.sourceOrdinal);
                const destTruck = dispatchTrucks.find(ic => ic.ordinal === value.destOrdinal);
                if (sourceTruck && destTruck) {
                    const sourceExpense = sourceTruck.items.find(e => e.expenseId === dispatchItem.expenseId);
                    const destExpense = destTruck.items.find(e => e.expenseId === dispatchItem.expenseId);
                    if (sourceExpense && destExpense) {
                        sourceExpense.quantity -= Number(value.quantity);
                        destExpense.quantity += Number(value.quantity);
                    } else if (sourceExpense) {
                        sourceExpense.quantity -= Number(value.quantity);
                        destTruck.items.push({
                            expense: dispatchItem.expense,
                            expenseId: dispatchItem.expenseId,
                            id: "",
                            price: dispatchItem.price,
                            product: dispatchItem.product,
                            productId: dispatchItem.productId,
                            quantity: Number(value.quantity),
                        });
                    }

                }
            });
        }
        
        dispatchTrucks.forEach((value => value.items = value.items.filter(i => i.quantity !== 0)));

        this.setState({
            dispatchItem: undefined,
            dispatchTrucks,
            isDirty: true,
            reallocateModal: false,
            reallocations: [],
        });
    }

    private clearReallocation = () => {
        this.setState({
            dispatchItem: undefined,
            reallocateModal: false,
            reallocations: [],
        });
    }

    public handleEdit = (dispatchTruckOrdinal: number) => (index: number) => {
        const dispatchTruck = this.state.dispatchTrucks.find(ic => ic.ordinal === dispatchTruckOrdinal);
        if (dispatchTruck === undefined) {
            return;
        }
        const dispatchItem = dispatchTruck.items[index];
        this.setState({
            dispatchItem,
            reallocateModal: true,
        });
    }

    private toggleEditable = () => {
        const disableEditing = !this.state.disableEditing;
        this.setState({
            disableEditing
        });
    }

    private getStatusColor = (status: string) => {
        switch (status) {
            case 'Submitted':
            case 'Completed':
                return 'primary';
            case 'Approved':
            case 'Confirmed':
                return 'success';
            case 'Rejected':
            case 'Denied':
                return 'danger';
        }
        return 'primary';
    }

    private noDestinationWell = () => {
        return this.state.destinationWellId === '';
    }

    private renderActionButtons = () => {
        if (this.state.statusIndex > 0) {
            return '';
        }
        const displayStatus = this.DispatchStore.dispatch.dispatchHistory[0];
        const sourceWell = displayStatus.dispatchHeader.sourceWell;
        const destinationWell = displayStatus.dispatchHeader.destinationWell;
        const canApproveAll = this.UserStore.hasPermission('Permissions.Dispatch.Approve.All');
        const canApproveAssigned = this.UserStore.hasPermission('Permissions.Dispatch.Approve.Assigned');
        const isAssigned = this.UserStore.user !== undefined && ((sourceWell && sourceWell.engineerIds && sourceWell.engineerIds.some(id => id === this.UserStore.user.id))
            || (destinationWell && destinationWell.engineerIds && destinationWell.engineerIds.some(id => id === this.UserStore.user.id)));
        const canApprove = this.state.statusIndex === 0 && (canApproveAll 
            || (canApproveAssigned && isAssigned));
        const canUpdateRejectedAll = this.UserStore.hasPermission('Permissions.Dispatch.UpdateRejected.All');
        const canUpdateRejectedAssigned = this.UserStore.hasPermission('Permissions.Dispatch.UpdateRejected.Assigned');
        const canUpdateRejected = canUpdateRejectedAll || (isAssigned && canUpdateRejectedAssigned);
        const canConfirm = this.state.statusIndex === 0 && this.UserStore.hasPermission('Permissions.Dispatch.Confirm');
        const canCancelAll = this.UserStore.hasPermission('Permissions.Dispatch.Cancel.All');
        const canCancelAssigned = this.UserStore.hasPermission('Permissions.Dispatch.Cancel.Assigned');
        const canCancel = canCancelAll || (isAssigned && canCancelAssigned);
        const status = displayStatus.status;
        const truckEmpty = this.state.dispatchTrucks.some(dt => dt.items.length === 0);
        const dispatchHasTruckEtas = this.state.dispatchTrucksHaveEta.every(dt => dt);
        const noDestWellOnTransfer = displayStatus.dispatchHeader.type === 'Transfer' 
            && (displayStatus.dispatchHeader.destinationWellId === null || displayStatus.dispatchHeader.destinationWellId === '')
            && this.state.destinationWellId === '';

        const renderCancel = () => canCancel &&
            <Button color="danger" disabled={truckEmpty} style={fontSizeStyle} onClick={this.handleStatusChange('Cancelled')}>
                Cancel
            </Button>;
        
        if (status === 'Cancelled')
        {
            return '';
        }

        if (canApprove) {
            switch (status) {
                case 'Submitted':
                    return <React.Fragment>
                        <Button color="success" disabled={truckEmpty || noDestWellOnTransfer} style={fontSizeStyle} onClick={this.handleStatusChange('Approved')}>
                            Approve
                        </Button>{' '}
                        <Button color="danger" disabled={truckEmpty} style={fontSizeStyle} onClick={this.handleStatusChange('Rejected')}>
                            Reject
                        </Button>{' '}
                        {renderCancel()}
                    </React.Fragment>;
                case 'Rejected':
                    return <React.Fragment>
                        <Button color="success" disabled={truckEmpty} style={fontSizeStyle} onClick={this.handleStatusChange('Approved')}>
                            Approve
                        </Button>{' '}
                        {renderCancel()}
                    </React.Fragment>;
            }
        }

        if (canConfirm) {
            switch (status) {
                case 'Approved':
                    return <React.Fragment>
                        <Button color="success" disabled={truckEmpty || !dispatchHasTruckEtas} style={fontSizeStyle} onClick={this.handleStatusChange('Confirmed')}>
                            Confirm
                        </Button>{' '}
                        <Button color="danger" disabled={truckEmpty} style={fontSizeStyle} onClick={this.handleStatusChange('Denied')}>
                            Deny
                        </Button>{' '}
                    </React.Fragment>;
                case 'Denied':
                    return <React.Fragment>
                        {renderCancel()}
                    </React.Fragment>;
            }
        }

        if (canUpdateRejected && status === 'Rejected') {
            return <React.Fragment>
                <Button color="success" disabled={truckEmpty} style={fontSizeStyle} onClick={this.handleStatusChange('Submitted')}>
                    Resubmit
                </Button>
                {renderCancel()}
            </React.Fragment>;
        }

        if (canCancel) {
            switch (status) {

                case 'Rejected':
                case 'Submitted':
                case 'Denied':
                    return <Button color="danger" disabled={truckEmpty} style={fontSizeStyle} onClick={this.handleStatusChange('Cancelled')}>
                    Cancel
                </Button>;
            }
        }

        return '';

    }

    private handleDestWellChange = (event: any) => {
        this.setState({
            destinationWellId: event.target.value
        });
    }

    private handleSaveNewProducts = () => {
        const trucks = this.state.dispatchTrucks;
        const list = trucks[0].items;
        
        if ( this.state.newInventoryList.length > 0 ) {
            this.state.newInventoryList.forEach((product: IProduct, index: number) => {
                if (!list.find(li => li.productId === product.id)) {

                    const newDispatchItem = new IDispatchItem();
                    newDispatchItem.product = product;
                    newDispatchItem.productId = product.id;
                    newDispatchItem.quantity = '';
                    list.push(newDispatchItem);
                }
            });
        }

        if ( this.state.newExpenseList.length > 0) {
            if ( this.state.newExpenseList.length > 0) {
                this.state.newExpenseList.forEach(expense => {
                    if (!list.find(li => li.expenseId === expense.id)) {
                        const newDispatchItem = new IDispatchItem();
                        newDispatchItem.expense = expense;
                        newDispatchItem.expenseId = expense.id;
                        newDispatchItem.quantity = '';
                        list.push(newDispatchItem);
                    }
                });
            }
        }
        this.setState({
            dispatchTrucks: trucks,
            isDirty: true,
            newExpenseList: [],
            newInventoryList: [],
            showProductModal: false,
        });
    }

    private handleDeleteProducts = (dispatchTruckIndex: number) => (index: number) => {
        const trucks = this.state.dispatchTrucks;
        const currTruck = trucks[dispatchTruckIndex];
        currTruck.items.splice(index, 1);
        this.setState({
            dispatchTrucks: trucks,
        });
    }

    private formatDataTableProduct = (truckNumber: number, dispatchItems: IDispatchItem[]) => {
        const list = dispatchItems;
        
        const headers = [
            'Item',
            'Category',
            'Unit',
            'Size',
            'Price',
            'Quantity',
        ];

        const rows: any = list.map((row, index) =>
            row.product ? [
                {
                    content: row.product.name
                },
                {
                    content: row.product.categorys.length > 0 ? row.product.categorys[0].name : ''
                },
                {
                    content: row.product.unit
                },
                {
                    content: row.product.size
                },
                {
                    content: mask.currency(row.price),
                    sortItem: row.price,
                },
                {
                    content: this.createQuantityInput('product', truckNumber, index, row),
                    sortItem: row.quantity,
                    type: 'render',

                }
        ] : [
            {
                content: row.expense.name,
            },
            {
                content: row.expense.isRental ? 'Rental' : 'Service',
            },
            {
                content: ''
            },
            {
                content: ''
            },
            {
                content: this.createPriceInput('expense', truckNumber, index, row),
                sortItem: row.price,
                type: 'render',
            },
            {
                content: this.createQuantityInput('expense', truckNumber, index, row),
                sortItem: row.quantity,
                type: 'render',
            }
        ]);

        const retList = {
            headers,
            rows,
        };
        
        return retList;
    }

    public render() {
        const dispatch = this.DispatchStore.dispatch;
        const dispatchItem = this.state.dispatchItem;
        if (!dispatch) {
            return '';
        }
        const displayStatus = dispatch.dispatchHistory[this.state.statusIndex];
        const currentDispatchStatus = dispatch.dispatchHistory[0].status;
        const dispatchType = this.DispatchStore.getDispatchType(displayStatus);
        const sourceWell = displayStatus.dispatchHeader.sourceWell;
        const destinationWell = displayStatus.dispatchHeader.destinationWell;
        const submittedTest = displayStatus.dispatchHeader.submittedWellTest;
        const receivedTest = displayStatus.dispatchHeader.receivedWellTest;
        const wellTimeZone = sourceWell ? sourceWell.timeZoneName : destinationWell.timeZoneName;
        const receivedTimeZone = destinationWell ? destinationWell.timeZoneName : '';
        const canConfirm = this.state.statusIndex === 0 && this.UserStore.hasPermission('Permissions.Dispatch.Confirm');
        const truckEmpty = this.state.dispatchTrucks.some(dt => dt.items.length === 0);
        return (

            <div className="dispatch-details">
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <Row>
                    <Col>
                        <h4 style={{fontSize: '2.4rem'}}>Dispatch Details - Request for {dispatchType}</h4>
                    </Col>
                </Row>
                <Row>
                    <Col md="6">

                        {
                            destinationWell ?
                        
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>To:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <h3>{ destinationWell.wellName }</h3>
                            </Col>
                        </Row>
                        :
                            displayStatus.dispatchHeader.type === 'Transfer' &&
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>To:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <EInput
                                        type="select"
                                        id="destinationWell"
                                        name="destinationWell"
                                        value={this.state.destinationWellId}
                                        onChange={this.handleDestWellChange}
                                        errorCallback={{
                                            callback: this.noDestinationWell,
                                            message: 'In order to take any action on transfer you must select a destination well',
                                        }}
                                >
                                                                    <option />
                                {
                                    this.state.wellList &&
                                    this.state.wellList.filter(w => w.id !== displayStatus.dispatchHeader.sourceWellId).map((well, index) => 
                                        <option key={well.id} value={well.id}>
                                            {well.wellName}
                                        </option>
                                    )
                                }
                                </EInput>
                            </Col>
                        </Row>
                        }
                        {
                            sourceWell &&
                        
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>From:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <h3>{ sourceWell.wellName }</h3>
                            </Col>
                        </Row>
                        }
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>Submitted Test Date:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <h3>
                                    { 
                                    submittedTest
                                    ? moment.unix(submittedTest.testDate).tz(wellTimeZone).format("MMM DD YYYY, h:mm a")
                                    : 'Spud Load'}
                                </h3>
                            </Col>
                        </Row>
                        {
                            receivedTest &&
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>Received Test Date:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <h3>
                                    {moment.unix(receivedTest.testDate).tz(receivedTimeZone).format("MMM DD YYYY, h:mm a")}
                                </h3>
                            </Col>
                        </Row>
                        }
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>Requested Time of Arrival:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <h3>{  moment.unix(Number(displayStatus.requestedArrival)).format("MMM DD YYYY, h:mm a") }</h3>
                            </Col>
                        </Row>
                        {/* 
                        REMOVED MUD-3620
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>Estimated Time of Arrival:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <h3>{  displayStatus.estimatedArrival ? moment.unix(Number(displayStatus.estimatedArrival)).format("MMM DD YYYY, h:mm a") : 'Not Set' }</h3>
                            </Col>
                        </Row> 
                        */}
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>Status Update User:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <h3>{ displayStatus.statusChangeBy }</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>Status Update Date:</h3>
                            </Col>
                            <Col xs={rightColumnWidth}>
                                <h3>{  moment.unix(Number(displayStatus.statusChangeDate)).format("MMM DD YYYY, h:mm a") }</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>Status:</h3>
                            </Col>
                            <Col xs={12-leftColumnWidth}>
                                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
                                    <DropdownToggle color={this.getStatusColor(displayStatus.status)} style={fontSizeStyle} caret={true}>
                                        { displayStatus.status }
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem header={true}>Current Status</DropdownItem>
                                        <DropdownItem onClick={this.changeDisplayStatus(0)}>{dispatch.dispatchHistory[0].status}</DropdownItem>
                                        <DropdownItem divider={true} />
                                        <DropdownItem header={true}>Previous Status</DropdownItem>
                                        {
                                            dispatch.dispatchHistory.map((item, index) => {
                                                if (index > 0) {
                                                    return (
                                                        <DropdownItem key={item.id} onClick={this.changeDisplayStatus(index)}>
                                                            {item.status}
                                                            -
                                                            {moment.unix(Number(item.statusChangeDate)).format("MMM DD YYYY, h:mm a")}
                                                            -
                                                            {item.statusChangeBy}
                                                        </DropdownItem>
                                                    );
                                                }
                                                return '';
                                            })
                                        }
                                    </DropdownMenu>
                                </Dropdown>
                            </Col>
                        </Row>
                        <Row style={{margin: '15px -15px'}}>
                            <Col xs={leftColumnWidth}>
                                <h3 style={boldStyle}>
                                    Actions:
                                </h3>
                            </Col>
                            <Col>
                            {
                                this.renderActionButtons()
                            }
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <h3 style={boldStyle}>Dispatch Comments:</h3>
                                <div className="well-story">
                                    {   dispatch.comments &&
                                        dispatch.comments.map((story, index) =>
                                        <div key={index}>
                                            {story.comment.split('\n').map((remark, indexRem) => {
                                                if(remark === '') {
                                                    return <br key={indexRem} />;
                                                }
                                                return <p key={indexRem} className="the-remark">{remark}</p>;
                                            })
                                            }
                                            <p className="remark-datetime">
                                                {story.commentBy + ' | ' + moment(story.commentDate, 'X').format('LLL')}
                                            </p>
                                        </div>
                                    ) }
                                </div>
                            </Col>
                        </Row>
                        {
                            this.UserStore.hasPermission("Permissions.Dispatch.Comment") &&
                        <React.Fragment>
                            <Row>
                                <Col>
                                    <Input
                                        type="textarea"
                                        rows="3"
                                        name="comment"
                                        id="comment"
                                        value={this.state.comment}
                                        onChange={this.handleChangeComment}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button style={{margin: "1rem"}} color="primary" onClick={this.handleAddComment}>Add Comment</Button>
                                    <Button className="secondary" onClick={this.clearComment}>Clear Comment</Button>
                                </Col>
                            </Row>
                        </React.Fragment>
                        }
                    </Col>
                </Row>
                {
                    this.state.dispatchTrucks.map((dt, index) => 
                    <React.Fragment key={dt.id === '' ? index : dt.id}>
                        <h4>
                        <Row>
                                <Col>
                                    <span onClick={this.handleTruckOpen(index)}>
                                        <OpenArrow open={this.state.dispatchTruckOpen[index]} />
                                        Truck {dt.ordinal}:
                                        {' '}
                                        {
                                            dt.status &&
                                            `Current Status: ${dt.status}`
                                        }
                                    </span>
                                </Col>
                            {
                                canConfirm && dt.status === 'Confirmed' && destinationWell &&
                                <Col>
                                    <Button color="primary" disabled={!this.state.dispatchTrucksHaveEta[index]} onClick={this.handleTruckDelivery(dt)}>Set Status En Route</Button>
                                </Col>
                            }
                            {
                                canConfirm && dt.status === 'Delivered' && !destinationWell &&
                                <Col>
                                    <Button color="primary" onClick={this.handleTruckCompleted(dt)}>Set Status Completed</Button>
                                </Col>
                            }
                            {
                                this.canEditDispatch() && dt.items.length === 0 &&
                                <Col>
                                    <span style={{float: 'right', marginRight: '1rem'}} onClick={this.removeTruck(index)}>
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                    </span>
                                </Col>
                            }
                        </Row>
                            </h4>
                            {
                                this.state.dispatchTruckOpen[index] &&
                                dt.items.length > 0 &&
                                <FormGroup row={true}>
                                    <Col md="3">
                                        <Label className="required">
                                            Estimated Time of Arrival
                                        </Label>
                                    </Col>
                                    <Col md="3">
                                        <DateTime
                                            value={ dt.estimatedArrival ? moment.unix(Number(dt.estimatedArrival)) : undefined }
                                            onChange={this.handleEstimatedArrivalChange(index)}
                                            inputProps={{disabled: !this.canSetDispatchEstimatedArrival()}}
                                        />
                                    </Col>
                                    {
                                        dt.estimatedArrival && !this.state.dispatchTrucksHaveEta[index] &&
                                        <Col>
                                            <Label className="required">
                                                Dispatch Truck Status cannot be updated until ETA is saved.  To save click the Update Dispatch Trucks button.
                                            </Label>
                                        </Col>
                                    }
                                    {
                                        !dt.estimatedArrival &&
                                        currentDispatchStatus === 'Approved' &&
                                        <Col>
                                            <Label className="required">
                                                Dispatch Cannot be confirmed until an ETA is set for every Truck.
                                            </Label>
                                        </Col>
                                    }
                                </FormGroup>
                            }
                        {
                            this.state.dispatchTruckOpen[index] &&
                            (dt.items.length > 0 ?
                            <Row>
                                <Col>
                                    <DataTable 
                                        list={this.formatDataTableProduct(dt.ordinal, dt.items)}
                                        onEdit={this.canReallocate() ? this.handleEdit(dt.ordinal) : undefined}
                                        onDelete={this.canAddProducts() ? this.handleDeleteProducts(index) : undefined}
                                    />
                                </Col>
                            </Row>
                            :
                            <Row>
                                <Col>
                                <p style={{color: 'red', fontSize: '1.5rem'}}>Dispatch Truck {dt.ordinal} is empty.  Dispatch Trucks cannot be updated and dispatch status cannot be changed until items are added or the truck is deleted.  To add items reallocate them from another truck by clicking on the edit icon. To Delete click the trashcan icon.</p>
                                </Col>
                            </Row>)
                        }
                    </React.Fragment>
                    )
                }
                <Row>
                    <Col>
                        <div className="float-right">
                            {
                                this.canReallocate() &&
                                <Button color="primary" onClick={this.addTruck}>Add Truck</Button>
                            }
                            {' '}
                            {
                                this.canAddProducts() && 
                                <Button color="primary" onClick={this.toggleModal('product')}>Add Products</Button>
                            }
                            {' '}
                            {
                                this.canAddProducts() && 
                                <Button color="primary" onClick={this.toggleModal('expense')}>Add EBP</Button>
                            }
                            {' '}
                            {
                                this.canEditDispatch() &&
                                <Button className="secondary" onClick={this.toggleEditable}>{this.state.disableEditing ? 'Enable' : 'Disable'} Editing</Button>
                            }
                            {' '}
                            {
                                this.canEditDispatch() &&
                                <Button color= "primary" disabled={truckEmpty} onClick={this.saveDispatch}>Update Dispatch Trucks</Button>
                            }
                        </div>
                    </Col>
                </Row>
                {
                    this.canReallocate() &&
                <Modal size="lg" isOpen={this.state.reallocateModal} toggle={this.clearReallocation}>
                    <ModalHeader toggle={this.clearReallocation}>
                        Reallocate Items
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <DataTable
                                    list={this.renderDispatchItem(dispatchItem)}
                                />
                            </Col>
                        </Row>
                        {
                            this.getCurrentAllocations().map((value, index) => 
                                    <Row key={index}>
                                        <Col>
                                            <FormGroup>
                                                <Label>Truck</Label>
                                                <Input
                                                    type="text"
                                                    value={value.ordinal}
                                                    disabled={true}
                                                    />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label>Quantity</Label>
                                                <EInput
                                                    type="text"
                                                    value={ value.quantity }
                                                    data-validation="decimal"
                                                    disabled={true}
                                                    />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                            )
                        }
                        {
                            this.state.reallocations.map((value, index) => 
                                <Row key={index}>
                                    <Col>
                                        <FormGroup className="required">
                                            <Label>From</Label>
                                            <EInput
                                                type="select"
                                                name="sourceOrdinal"
                                                value={value.sourceOrdinal}
                                                required={true}
                                                onChange={this.handleSourceDestUpdate(index)}
                                            >
                                                <option />
                                                {
                                                    this.state.dispatchTrucks.filter(this.filterDispatchTrucks).map(val =>
                                                        <option key={val.ordinal} value={val.ordinal}>Truck {val.ordinal}</option>
                                                    )
                                                }
                                            </EInput>
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup className="required">
                                            <Label>To</Label>
                                            <EInput
                                                type="select"
                                                name="destOrdinal"
                                                value={value.destOrdinal}
                                                required={true}
                                                onChange={this.handleSourceDestUpdate(index)}
                                            >
                                                <option />
                                                {
                                                    this.state.dispatchTrucks.filter(ic => ic.ordinal !== value.sourceOrdinal).map(val =>
                                                        <option key={val.ordinal} value={val.ordinal}>Truck {val.ordinal}</option>
                                                    )
                                                }
                                            </EInput>
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup className="required">
                                            <Label>Quantity</Label>
                                            <EInput
                                                type="text"
                                                name="quantity"
                                                value={value.quantity}
                                                required={true}
                                                data-validation={this.state.dispatchItem.product 
                                                    && this.state.dispatchItem.product.isBulk ? "decimal" : "integer"}
                                                decimal-places="2"
                                                onChange={this.handleAmountUpdate(index)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="1">
                                        <div style={{marginTop: '1rem'}} onClick={this.handleReallocationDelete(index)}>
                                            <FontAwesomeIcon icon={faTrashAlt} size="2x" />
                                        </div>  
                                    </Col>
                                </Row>
                            )
                        }
                        <Row>
                            <Col>
                                <Button color="primary" onClick={this.addNewReallocation}>New Reallocation</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.clearReallocation}>Cancel</Button>
                        <EButton color="primary" onClick={this.saveReallocation}>Save</EButton>
                    </ModalFooter>
                </Modal>
                }
                {
                    this.state.showProductModal &&
                    <Modal isOpen={this.state.showProductModal} fade={false} toggle={this.toggleModal('product')} style={{'maxWidth': 'fit-content'}}>
                    <ModalHeader toggle={this.toggleModal('product')}>{this.state.tab === 'product' ? 'Product' : 'EBP'} List</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="12">
                                <DataTable
                                    list={this.state.tab === 'product' ? this.formatAddProductDataTable() : this.formatAddExpenseDataTable()}
                                    onMultiSelect={this.handleMultiSelect(this.state.tab)}
                                />
                            </Col>
                        </Row>
                        {/* <div className="add-table-row">
                            <Button className="primary add-new-button" onClick={this.toggleModal('newProduct')}>
                                        <FontAwesomeIcon icon="plus" />
                                        { ' User Defined Product' }
                            </Button>
                        </div> */}
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleModal('product')}>Cancel</Button>
                        <Button color="primary" onClick={this.handleSaveNewProducts}>Add to Dispatch</Button>
                    </ModalFooter>
                </Modal>
                }
            </div>
        );
    }
}

export default withRouter(DispatchDetails);


// WEBPACK FOOTER //
// ./src/Components/Main/Dispatch/DispatchDetails/DispatchDetails.tsx